import React, { useEffect } from 'react';
import { Field } from 'formik'
import { FormikSelectComponent } from '../../../utilities/formUtils'


const SyncOptions = ({ name, isTxn, isLabel, label, isSelection, placeholder, userProps, width, callback, index, type }, props) => {

    const options = [
        { key: 1, text: 'Trans Id', value: 'trans_id'},
        { key: 2, text: 'Trans Ref No.', value: 'trans_ref_num' },
        { key: 3, text: 'Trans Date', value: 'trans_date' },
        { key: 4, text: 'Sync Date', value: 'sync_date' },
      ]

      
    return (
        <Field name={name} isLabel={isLabel} isTxn={isTxn} label={label} isSelection={isSelection} component={FormikSelectComponent} userProps={{ options, index, placeholder }} placeholder={placeholder} width={width}> </Field>
    )

}


export default SyncOptions;